import angular from 'angular'
import { WebRegisterStatusManager } from '../managers/web-register-status-manager'

import { $injector, $log, $q } from '../ng-compat/imports'

/**
 * Intercepts $http requests and aborts all requests made to the API when the application is offline.
 *
 * @module webregister.http.abortRequestWhenOffline
 */
angular
  .module('webregister.http')
  .factory('abortRequestWhenOffline', function () {
    const REQUEST_BLOCKED_MESSAGE = 'Request blocked as application is offline'

    function isAbortableRequest(config: $TSFixMe) {
      return config.url.indexOf('/api') === 0
    }

    function onRequest(config: $TSFixMe) {
      return $q((resolve, reject) => {
        // We can't inject webRegisterStatusManager otherwise we have a cyclic dependency so get it at runtime from the
        // $injector service
        const webRegisterStatusManager = $injector.get<WebRegisterStatusManager>(
          'webRegisterStatusManager'
        )
        const offline =
          webRegisterStatusManager && !webRegisterStatusManager.isOnline()

        if (offline && isAbortableRequest(config)) {
          $log.debug(REQUEST_BLOCKED_MESSAGE, config)

          // "Abort! Dive, dive, dive!" - The Skipper
          reject({
            config,
            status: 0,
            statusText: REQUEST_BLOCKED_MESSAGE,
            data: REQUEST_BLOCKED_MESSAGE,
          })
        } else {
          resolve(config)
        }
      })
    }

    return {
      request: onRequest,
    }
  })
